import AlertService from '@/shared/alert/alert.service';
import { Area } from '@/shared/model/enumerations/area';
import { EntidadLegajo, EventoLegajo } from '@/shared/model/legajo/legajo.constant';
import { FiltroLegajo, Legajo, MenuEntidadLegajo, MenuEventoLegajo } from '@/shared/model/legajo/legajo.model';
import LegajoService from '@/shared/services/LegajoService';
import { BvTableFieldArray } from 'bootstrap-vue';
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { formatDateHoraSegundos } from '@/shared/date/date-utils';
import DetalleLegajoComponent from '@/components/legajo/consultar-legajo/detalle-legajo.vue';

@Component({
  components: {
    'detalle-legajo': DetalleLegajoComponent,
  },
})
export default class ConsultaLegajosComponent extends Vue {
  @Inject('legajoService') private readonly legajoService!: () => LegajoService;
  @Inject('alertService') private readonly alertService!: () => AlertService;

  @Prop({ required: true })
  public area!: Area;

  @Prop({ required: true })
  public entidadesLegajo!: Array<EntidadLegajo>;

  @Prop({ required: true })
  public eventosLegajo!: Array<EventoLegajo>;

  @Prop({ required: false, default: undefined })
  public solucionId!: string;

  @Prop({ required: false, default: undefined })
  public solicitudId!: string;

  @Prop({ required: false, default: undefined })
  public participacionId!: string;

  @Prop({ required: false, default: false })
  public mostrarTextoEnBoton!: boolean;

  public opcionesEntidades: Array<MenuEntidadLegajo> = this.generarOpcionesEntidades();
  public opcionesEventos: Array<MenuEventoLegajo> = this.generarOpcionesEventos();
  public filtroLegajo: FiltroLegajo = new FiltroLegajo();

  public legajoSeleccionado: Legajo = new Legajo();

  public modalVisible = false;

  public legajos: Array<Legajo> = [];
  private consultandoLegajos = false;
  public registros = 0;
  public perPage = 25;
  public currentPage = 1;
  public readonly pageOptions: Array<number> = [5, 15, 25, 50, 100, 150];

  public fieldsLegajo: BvTableFieldArray = [
    { key: 'entidadLegajo', label: this.$t('apeironGwApp.legajo.campos.entidadLegajo').toString() },
    { key: 'eventoLegajo', label: this.$t('apeironGwApp.legajo.campos.eventoLegajo').toString() },
    { key: 'tag', label: this.$t('apeironGwApp.legajo.campos.tag').toString() },
    { key: 'createdBy', label: this.$t('apeironGwApp.legajo.campos.createdBy').toString() },
    { key: 'nombreCompletoBy', label: this.$t('apeironGwApp.legajo.campos.nombreCompletoBy').toString() },
    {
      key: 'createdDate',
      label: this.$t('apeironGwApp.legajo.campos.createdDate').toString(),
      formatter: value => formatDateHoraSegundos(value),
    },
    { key: 'acciones', label: this.$t('apeironGwApp.legajo.campos.acciones').toString(), class: 'text-center' },
  ];

  public iniciarComponente(): void {
    this.filtroLegajo = new FiltroLegajo();
    this.legajoSeleccionado = new Legajo();
    this.legajos = [];
  }

  public mostrarModal(): void {
    this.iniciarComponente();
    this.modalVisible = true;
  }

  public cambiarPagina(pagina: number) {
    this.currentPage = pagina;
    this.consultarLegajos();
  }

  public buscarDesdePrimerPagina() {
    this.currentPage = 1;
    this.consultarLegajos();
  }

  private consultarLegajos(): void {
    this.consultandoLegajos = true;
    this.legajoSeleccionado = new Legajo();
    const paginationQuery = {
      page: this.currentPage - 1,
      size: this.perPage,
      sort: ['area,desc', 'entidadLegajo,desc', 'createdDate,desc'],
      filter: FiltroLegajo.fromObject(this.filtroLegajo),
    };
    paginationQuery.filter.area = this.area;
    paginationQuery.filter.solucionId = this.solucionId;
    paginationQuery.filter.solicitudId = this.solicitudId;
    paginationQuery.filter.participacionId = this.participacionId;
    paginationQuery.filter.entidadesLegajo = this.entidadesLegajo;
    paginationQuery.filter.eventosLegajo = this.eventosLegajo;
    this.legajoService()
      .obtenerLegajos(paginationQuery)
      .then(result => {
        this.legajos = (result.data ?? []).map(Legajo.fromObject);
        this.registros = Number(result.headers['x-total-count']);
      })
      .catch(error => {
        if (!!error.response?.data?.detail) {
          this.alertService().showError(this, error.response.data.detail);
        } else {
          this.alertService().showHttpError(this, error.response);
        }
      })
      .finally(() => {
        this.consultandoLegajos = false;
      });
  }

  public seleccionarLegajo(item: Legajo): void {
    this.legajoSeleccionado = Legajo.fromObject(item);
  }

  private generarOpcionesEventos(): Array<MenuEventoLegajo> {
    return this.eventosLegajo.map(
      evento => new MenuEventoLegajo(this.$t(`apeironGwApp.legajo.eventos.${evento}`).toString(), <EventoLegajo>evento)
    );
  }

  private generarOpcionesEntidades(): Array<MenuEntidadLegajo> {
    return this.entidadesLegajo.map(
      entidad => new MenuEntidadLegajo(this.$t(`apeironGwApp.legajo.entidades.${entidad}`).toString(), <EntidadLegajo>entidad)
    );
  }

  public manejaOcultarDetalles(): void {
    this.legajoSeleccionado = new Legajo();
  }

  get consultandoElBack(): boolean {
    return this.consultandoLegajos;
  }
}
